var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadIconSmall = function SvgUploadIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#237C82",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.083.75v6.667m0-6.667c-.467 0-1.339 1.33-1.666 1.667M6.083.75c.467 0 1.34 1.33 1.667 1.667M11.417 8.751c0 1.655-.346 2-2 2H2.75c-1.655 0-2-.345-2-2"
  })));
};
export default SvgUploadIconSmall;